import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";
import { useLoginForm } from "@/hooks/auth/useLoginForm";
import { useAppSelector } from "@/redux/features/hooks";
import { useNavigate } from "react-router-dom";
import LoginLayout from "./LoginLayout";

const Login = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const { register, errors, onSubmit, isLoading } = useLoginForm();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const handleBackButton = (e: PopStateEvent) => {
      e.preventDefault();
      
      if ('serviceWorker' in navigator && window.matchMedia('(display-mode: standalone)').matches) {
        window.close();
      }
    };

    window.addEventListener('popstate', handleBackButton);

    window.history.pushState(null, '', window.location.href);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <LoginLayout>
      <h2 className="mb-6 font-semibold text-xl text-card-foreground">
        Connectez-vous
      </h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Input
            label="Email ou Numéro de Téléphone"
            type="text"
            id="emailOrPhone"
            placeholder="ex: email@exemple.com ou +221 77 123 45 67"
            {...register("emailOrPhone")}
            error={errors?.emailOrPhone}
          />
        </div>

        <Button
          type="submit"
          className="w-full h-auto py-4"
          isLoading={isLoading}
        >
          Me connecter
        </Button>
      </form>
    </LoginLayout>
  );
};

export default Login;
